import $ from 'jquery'

export default {
    name: 'login',
    components: {},
    props: [],
    data() {
        return {
            status: null,
            loginData: {
                email: '',
                password: ''
            },
            loading: false
        }
    },
    computed: {

    },
    mounted() {
        console.log(this.$router.history.current.name)
    },
    methods: {
        getLoginErrorStatus(error) {
            if (error && error.response && error.response.status) {
                return error.response.status
            }

            return 0
        },

        loginProcess: function() {
            this.loading = true
            let err = 0

            if (this.loginData.email == '') {
                $('.err-msg-1').fadeIn(500)
                err++
                this.$refs.email.focus();
            } else if (this.loginData.password == '') {
                $('.err-msg-2').fadeIn(500)
                err++
                this.$refs.pwd.focus();
            }

            if (err == 0) {
                this.$store.dispatch('login', this.loginData).then(
                    (response) => {
                        let role = response.user.roles
                        
                        // check if the logged user has the right rights
                        let access = false;
                        let canViewDashboard = false
                        for (let index = 0; index < role.length; index++) {
                            
                            if (
                                role[index].nom == "ROLE_RECEPTIONNISTE" || role[index].nom == "ROLE_COMPTABLE" ||
                                role[index].nom == "ROLE_CAISSIERE_INTERMITENT" || role[index].nom == "ROLE_ADMINISTRATEUR" || 
                                role[index].nom == "ROLE_CAISSIERE"
                            ) {
                                access = true

                                if (
                                    role[index].nom == "ROLE_RECEPTIONNISTE" || role[index].nom == "ROLE_CAISSIERE_INTERMITENT" || 
                                    role[index].nom == "ROLE_CAISSIERE"
                                ) {
                                    canViewDashboard = true
                                }
                                break;
                            } else {
                                access = false
                            }
                        }

                        if (access) { //he's allowed to pass
                            
                            if (canViewDashboard == false) {
                                // le comptable sera redirigé vers la caisse
                                this.$router.push({ path: '/clinicaa/comptabilite/caisse' });

                            } else {
                                // le receptionniste sera redirigé vers le tableau de bord
                                this.$router.push({ path: '/' });
                            }
                        } else { //NOT allowed
                            this.status = 403
                        }

                        this.loading = false;
                    }
                ).catch(error => {
                        this.loading = false
                        this.status = this.getLoginErrorStatus(error)
                    })
            } else {
                this.loading = false;
            }

        }, 

        clearError() {
            for(let i = 1; i < 3; i++) {
                $('.err-msg-'+i).fadeOut(500)
                this.status = ''
            }
        }

    }
}
